export default function OnlineMenusIcon({fill = '#333'}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 15.77"
      className="eighteen"
    >
      <g id="a" />
      <g id="b">
        <g id="c">
          <g>
            <path
              id="d"
              d="M15.55,14.79c-.03,.57-.51,1-1.08,.97-.02,0-.05,0-.07,0-.32-.08-.62-.23-.87-.44-1.39-1.09-2.64-2.35-3.72-3.74-.86-1.05-1.7-2.11-2.6-3.12-.59-.72-1.48-1.13-2.41-1.1-.64,0-1.26-.22-1.75-.63-.39-.31-.75-.66-1.07-1.04-.62-.73-1.23-1.48-1.84-2.21-.14-.17-.24-.35-.04-.53s.37-.08,.53,.08c.85,.85,1.69,1.7,2.54,2.54,.07,.07,.14,.14,.23,.2,.11,.09,.27,.08,.37-.03,.1-.1,.11-.26,.02-.37-.06-.08-.13-.16-.2-.23L1.15,2.68s-.1-.1-.14-.14c-.15-.15-.19-.32-.03-.48,.11-.13,.3-.14,.42-.03,.02,.02,.04,.04,.05,.06l1.44,1.44,1.2,1.2c.16,.16,.33,.34,.54,.14s.04-.39-.12-.55c-.82-.82-1.65-1.65-2.47-2.47l-.17-.17c-.15-.15-.2-.31-.04-.48,.17-.18,.35-.12,.5,.04l1.44,1.44c.41,.41,.82,.81,1.22,1.22,.15,.15,.32,.27,.5,.1,.2-.18,.07-.37-.09-.52L3.11,1.18c-.1-.1-.19-.19-.29-.29-.17-.16-.31-.33-.12-.55s.38-.1,.56,.05c.67,.56,1.34,1.11,2.01,1.66,.34,.28,.66,.59,.96,.91,.59,.58,.91,1.37,.91,2.19-.01,.85,.36,1.66,1.01,2.21,1.03,.94,2.12,1.79,3.2,2.67,1.39,1.08,2.65,2.33,3.74,3.71,.26,.29,.42,.65,.46,1.04Z"
              fill={fill}
            />
            <path
              id="e"
              d="M.98,15.77c-.57-.03-1-.52-.97-1.09,0-.04,0-.07,.01-.11,.09-.31,.24-.59,.44-.83,1.1-1.4,2.36-2.66,3.76-3.75,.58-.47,1.17-.93,1.73-1.42,.18-.15,.3-.14,.44,.02,.26,.3,.53,.58,.8,.87,.08,.09,.14,.16,.03,.29-1.35,1.8-2.86,3.47-4.52,4.99-.36,.33-.75,.62-1.17,.86-.17,.09-.36,.15-.56,.16Z"
              fill={fill}
            />
            <path
              id="f"
              d="M15.38,4.45h0c.81-1.41,.85-2.94-.02-3.81s-2.4-.83-3.81-.02h0c-.45,.26-.87,.58-1.24,.95-.48,.47-.87,1.03-1.16,1.64-.22,.48-.34,1-.36,1.53,0,.18-.01,.37-.03,.55h0c-.03,.38-.13,.74-.3,1.08-.06,.11,0,.17,.07,.23,.14,.15,.73,.74,.88,.88,.07,.06,.12,.12,.23,.07,.34-.17,.7-.27,1.08-.3h0c.18-.02,.36-.03,.55-.03,.53-.01,1.05-.13,1.53-.36,.61-.29,1.16-.68,1.64-1.16,.37-.37,.69-.79,.95-1.24Z"
              fill={fill}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
